import graphql__5bdd5ad87b299fd11989 from "./__generated__/ComplexMenuDesktopMainNavigation_navigationItems.graphql.js";
import graphql__499941045f76a6ecbe28 from "./__generated__/ComplexMenuDesktopMainNavigation_platform.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import ComplexMenuDesktopNavigationItem from "./ComplexMenuDesktopNavigationItem";

const ComplexMenuDesktopMainNavigation = props => {
  const navigationItems = useFragment(
    ComplexMenuDesktopMainNavigation_navigationItems,
    props.navigationItems
  );

  const platform = useFragment(ComplexMenuDesktopMainNavigation_platform, props.platform);
  const { primaryColor, centerMainMenu } = platform;

  const containerClassName = classNames(
    "d-flex",
    "w-100",
    "align-items-center",
    "margin-bottom-none",
    "complex-menu-desktop-main-navigation-container",
    "list-unstyled",
    {
      "justify-content-center": centerMainMenu,
      "justify-content-start": !centerMainMenu
    }
  );

  return (
    <ul className={containerClassName}>
      {navigationItems.map(navigationItem => (
        <ComplexMenuDesktopNavigationItem
          key={navigationItem.id}
          navigationItem={navigationItem}
          primaryColor={primaryColor}
        />
      ))}
    </ul>
  );
};

const ComplexMenuDesktopMainNavigation_navigationItems = graphql__5bdd5ad87b299fd11989;

const ComplexMenuDesktopMainNavigation_platform = graphql__499941045f76a6ecbe28;

export default ComplexMenuDesktopMainNavigation;
